/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'money',
})
export class MoneyPipe implements PipeTransform {
  transform(value: any, args?: string): any {
    if (!value) value = 0

    let ret = value.toLocaleString('en-US', { minimumFractionDigits: 2 })
    if (args) {
      switch (args.toLowerCase()) {
        case 'usd':
        case 'cad':
          ret = `$ ${ret}`
          break
      }
    }
    return ret
  }
}
